
import commonApi from "@/apis/common.api";
import gripUtil from "@/libs/grip.util";
import lodash from 'lodash';
import { $_GCD, $_DKD } from '@/confs/common.const.js';

export default {
    state: {
        // 최상단 탭
        tablist: [
            {code: 'hosPhar', title: '야간<br class="m-visible">병의원·약국', class:''},
            {code: 'apart', title: '부동산(아파트)<br class="m-visible">실거래내역', class:''},
            {code: 'incrude', title: '공공기관<br class="m-visible">일자리정보', class:''},
        ],
        selectedLfcnvncTab: 'hosPhar',

        // 병의원약국 메뉴
        hpCateList: [],
        hpCateMap: {},

        hCateList: [],
        pCateList: [],

        selectedHpCate: 'LFCNVNC_01',
        selectedLfcnvncItems: [],

        // 병원 데이터
        hosFacList: [],
        h01List: [],
        h02List: [],
        h03List: [],
        h04List: [],
        h05List: [],
        h06List: [],
        // 약국 데이터
        p07List: [],
        p08List: [],
        p09List: [],
        p10List: [],
        p11List: [],


        // 아파트
        // 아파트 탭
        apartTab: [
            {code: 'chart', name: '차트'},
            {code: 'list', name: '목록'},
        ],
        selectedAtTab: 'chart',
        aptList: [],
        /* 사용 x */
        aptMap: {},
        selectionList: [],

        /* 사용 x */
        selectedDate: '',

        // 공공일자리
        // 워크넷 채용정보
        workIncrudeInfo: [],
        // 워크넷 공채속보 및 정보
        workIncrudeList: [],
        // 서울시 채용시험 정보
        seoulWorkList: [],


        // 어게인파트
        aptFacList: [],
        selectMap: {},
        apartMap: {},
        selectedApt: '',
    },
    getters: {
        // 최상단 탭
        getTablist(state) {
            return state.tablist;
        },
        getSelectedLfcnvncTab(state) {
            return state.selectedLfcnvncTab;
        },
        // 병의원약국 메뉴
        getHpCateList(state) {
            return state.hpCateList;
        },
        getHpCateMap(state) {
            return state.hpCateMap;
        },
        getHCateList(state) {
            return state.hCateList;
        },
        getPCateList(state) {
            return state.pCateList;
        },
        getSelectedHpCate(state) {
            return state.selectedHpCate;
        },
        getSelectedLfcnvncItems(state) {
            return state.selectedLfcnvncItems;
        },
        // 병원 데이터
        getHosFacList(state) {
            return state.hosFacList;
        },
        getH01List(state) {
            return state.h01List;
        },
        getH02List(state) {
            return state.h02List;
        },
        getH03List(state) {
            return state.h03List;
        },
        getH04List(state) {
            return state.h04List;
        },
        getH05List(state) {
            return state.h05List;
        },
        getH06List(state) {
            return state.h06List;
        },
        // 약국 데이터
        getP07List(state) {
            return state.p07List;
        },
        getP08List(state) {
            return state.p08List;
        },
        getP09List(state) {
            return state.p09List;
        },
        getP10List(state) {
            return state.p10List;
        },
        getP11List(state) {
            return state.p11List;
        },
        // 아파트
        // 아파트 탭
        getApartTab(state) {
            return state.apartTab;
        },
        getSelectedAtTab(state) {
            return state.selectedAtTab;
        },
        getAptList(state) {
            return state.aptList;
        },
        getAptMap(state) {
            return state.aptMap;
        },
        getSelectionList(state) {
            return state.selectionList;
        },
        getSelectedDate(state) {
            return state.selectedDate;
        },

        // 공공일자리
        getWorkIncrudeInfo(state) {
            return state.workIncrudeInfo;
        },
        getWorkIncrudeList(state) {
            return state.workIncrudeList;
        },
        getSeoulWorkList(state) {
            return state.seoulWorkList;
        },



        
        getAptFacList(state) {
            return state.aptFacList;
        },
        getSelectMap(state) {
            return state.selectMap;
        },
        getApartMap(state) {
            return state.apartMap;
        },
        getSelectedApt(state) {
            return state.selectedApt;
        },

    },
    mutations: {
        // 최상단 탭
        SELECTED_LFCNVNC_TAB(state, selectedLfcnvncTab) {
            state.selectedLfcnvncTab = selectedLfcnvncTab;
        },
        // 병의원약국 메뉴
        HP_CATE_LIST(state, hpCateList) {
            state.hpCateList = hpCateList;
        },
        HP_CATE_MAP(state, hpCateMap) {
            state.hpCateMap = hpCateMap;
        },
        H_CATE_LIST(state, hCateList) {
            state.hCateList = hCateList;
        },
        P_CATE_LIST(state, pCateList) {
            state.pCateList = pCateList;
        },
        SELECTED_HP_CATE(state, selectedHpCate) {
            state.selectedHpCate = selectedHpCate;
        },
        SELECTED_LFCNVNC_ITEMS(state, selectedLfcnvncItems) {
            state.selectedLfcnvncItems = selectedLfcnvncItems;
        },
        // 병원 데이터
        HOS_FAC_LIST(state, hosFacList) {
            state.hosFacList = hosFacList;
        },
        H_01_LIST(state, h01List) {
            state.h01List = h01List;
        },
        H_02_LIST(state, h02List) {
            state.h02List = h02List;
        },
        H_03_LIST(state, h03List) {
            state.h03List = h03List;
        },
        H_04_LIST(state, h04List) {
            state.h04List = h04List;
        },
        H_05_LIST(state, h05List) {
            state.h05List = h05List;
        },
        H_06_LIST(state, h06List) {
            state.h06List = h06List;
        },
        // 약국 데이터
        P_07_LIST(state, p07List) {
            state.p07List = p07List;
        },
        P_08_LIST(state, p08List) {
            state.p08List = p08List;
        },
        P_09_LIST(state, p09List) {
            state.p09List = p09List;
        },
        P_10_LIST(state, p10List) {
            state.p10List = p10List;
        },
        P_11_LIST(state, p11List) {
            state.p11List = p11List;
        },
        // 아파트
        // 아파트 탭
        SELECTED_AT_TAB(state, selectedAtTab) {
            state.selectedAtTab = selectedAtTab;
        },
        APT_LIST(state, aptList){
            state.aptList = aptList;
        },
        APT_MAP(state, aptMap){
            state.aptMap = aptMap;
        },
        SELECTION_LIST(state, selectionList){
            state.selectionList = selectionList;
        },
        SELECTED_DATE(state, selectedDate){
            state.selectedDate = selectedDate;
        },

        // 공공일자리
        WORK_INCRUDE_INFO(state, workIncrudeInfo){
            state.workIncrudeInfo = workIncrudeInfo;
        },
        WORK_INCRUDE_LIST(state, workIncrudeList){
            state.workIncrudeList = workIncrudeList;
        },
        SEOUL_WORK_LIST(state, seoulWorkList){
            state.seoulWorkList = seoulWorkList;
        },

        APT_FAC_LIST(state, aptFacList){
            state.aptFacList = aptFacList;
        },
        SELECT_MAP(state, selectMap){
            state.selectMap = selectMap;
        },
        APART_MAP(state, apartMap){
            state.apartMap = apartMap;
        },
        SELECTED_APT(state, selectedApt){
            state.selectedApt = selectedApt;
        },
    },
    actions : {
        // 최상단 탭
        SET_SELECTED_LFCNVNC_TAB({commit}, selectedLfcnvncTab) {
            commit('SELECTED_LFCNVNC_TAB', selectedLfcnvncTab);
        },

        // 병의원약국 메뉴
        FETCH_HP_CATE_LIST({commit}) {
            return commonApi.fetchCodeListByCodeGroup($_GCD.LFCNVNC_HP_CATE)
                .then(res=>{
                    let map = gripUtil.toDict(res.data.data, 'commonCode');
                    let hcatelist = map['LFCNVNC_01'].codeList;
                    let pcatelist = map['LFCNVNC_02'].codeList;
                    // console.log('res', gripUtil.toDict(res.data.data, 'commonCode'));
                    commit('HP_CATE_LIST', res.data.data);
                    commit('H_CATE_LIST', hcatelist);
                    commit('P_CATE_LIST', pcatelist);
                    // commit('HP_CATE_MAP', gripUtil.toDict(res.data.data, 'commonCode'));
                });
        },
        SET_SELECTED_HP_CATE({commit}, selectedHpCate) {
            commit('SELECTED_HP_CATE', selectedHpCate);
        },
        SET_SELECTED_LFCNVNC_ITEMS({commit}, selectedLfcnvncItems) {
            commit('SELECTED_LFCNVNC_ITEMS', selectedLfcnvncItems);
        },
        // 병원 데이터
        FETCH_HOS_FAC_LIST({commit}) {
            return commonApi.fetchRepoDataList($_DKD.HOSPITAL).then(res => {
                commonApi.fetchRepoDataList($_DKD.HOSPITAL_SUGI).then(response => {
                    // console.log('hospital', res.data.data);
                    let list = res.data.data;
                    let lst = response.data.data;
                    
                    // 중복된 데이터가 있음
                    list = list.filter(d => {
                        return d.val12 != '02-000-0000' && d.val1 != 'A1116273';
                    });
                    let idxList = [];
                    // api 자료 수기로 대체
                    list.forEach(d => {
                        lst.forEach((data, idx) => {
                            if(d.val1 == data.val1) {
                                d = data;
                                idxList.push(idx);
                            }
                        });
                    });
                    // 대체된 자료 이외의 자료 추가
                    lst.forEach((d, idx) =>{
                        if(!idxList.includes(idx)) {
                            list.push(d);
                        }
                    })

                    // 야간진료(22시)
                    let h01List = [];
                    // 심야진료(22시 이후)
                    let h02List = [];
                    // 소아 야간('소아'+22시 이후)
                    let h03List = [];
                    // 일요일 진료
                    let h04List = [];
                    // 공휴일 진료
                    let h05List = [];
                    // 응급실 운영
                    let h06List = [];
                    list.forEach(data => {
                        // 야간진료(22시)
                        if(data.val15 <= 2200 && data.val15 > 2100
                            || data.val17 <= 2200 && data.val17 > 2100
                            || data.val19 <= 2200 && data.val19 > 2100
                            || data.val21 <= 2200 && data.val21 > 2100
                            || data.val23 <= 2200 && data.val23 > 2100
                            || data.val25 <= 2200 && data.val25 > 2100
                            || data.val27 <= 2200 && data.val27 > 2100
                            || data.val29 <= 2200 && data.val29 > 2100
                            || data.val2 == '강남365가정의학과의원'
                        ) {
                            // 일주일에 3일 이상으로 제한
                            let cnt = 0;
                            if(data.val15 <= 2200 && data.val15 > 2100) cnt++;
                            if(data.val17 <= 2200 && data.val17 > 2100) cnt++;
                            if(data.val19 <= 2200 && data.val19 > 2100) cnt++;
                            if(data.val21 <= 2200 && data.val21 > 2100) cnt++;
                            if(data.val23 <= 2200 && data.val23 > 2100) cnt++;
                            if(data.val25 <= 2200 && data.val25 > 2100) cnt++;
                            if(data.val27 <= 2200 && data.val27 > 2100) cnt++;
                            if(data.val29 <= 2200 && data.val29 > 2100) cnt++;
                            if(cnt >= 3 || data.val2 == '강남365가정의학과의원') {
                                h01List.push(data);
                            }
                        }
                        // 심야진료(22시 이후)
                        if(data.val15 > 2200
                            || data.val17 > 2200
                            || data.val19 > 2200
                            || data.val21 > 2200
                            || data.val23 > 2200
                            || data.val25 > 2200
                            || data.val27 > 2200
                            || data.val29 > 2200
                        ) {
                            let cnt = 0;
                            if(data.val15 > 2200) cnt++;
                            if(data.val17 > 2200) cnt++;
                            if(data.val19 > 2200) cnt++;
                            if(data.val21 > 2200) cnt++;
                            if(data.val23 > 2200) cnt++;
                            if(data.val25 > 2200) cnt++;
                            if(data.val27 > 2200) cnt++;
                            if(data.val29 > 2200) cnt++;
                            if(cnt >= 3) {
                                h02List.push(data);
                            }
                        }
                        // 소아 야간
                        // if((data.val15 >= 2200 && data.val15 <= 2230
                        //     || data.val17 >= 2200 && data.val17 <= 2230
                        //     || data.val19 >= 2200 && data.val19 <= 2230
                        //     || data.val21 >= 2200 && data.val21 <= 2230
                        //     || data.val23 >= 2200 && data.val23 <= 2230
                        //     || data.val25 >= 2200 && data.val25 <= 2230
                        //     || data.val27 >= 2200 && data.val27 <= 2230
                        //     || data.val29 >= 2200 && data.val29 <= 2230) && ( typeof data.val32 !== 'undefined' && (data.val32.includes('소아') || data.val32.includes('가정의학')))
                        // ) {
                        //     h03List.push(data);
                        // }
                        // 소아 야간은 엑셀대로 필터링
                        // if(['A1120676','A1118816','A1124074','A1124201','A1121274'].includes(data.val1)) {
                        //     h03List.push(data);
                        // }
                        // 소아 야간 데이터가 실 데이터와 달라서 수기자료로 변경
                        h03List = response.data.data;
    
    
                        // 일요일 진료
                        if(typeof data.val26 !== 'undefined' && data.val26 > 0) {
                            h04List.push(data);
                        }
                        // 공휴일 진료
                        if(typeof data.val28 !== 'undefined' && data.val28 > 0) {
                            h05List.push(data);
                        }
                        // 응급실 운영
                        if(data.val8 == '1') {
                            h06List.push(data);
                        }
                    });
                    // h06List.forEach(data =>{
                    //     console.log('data.val2;', data.val2);
                    // });
                    // 깊은 복사 안하면, 카테고리가 바뀜
    
                    // commit('H_01_LIST', gripUtil.cloneObject(h01List));
                    // commit('H_02_LIST', gripUtil.cloneObject(h02List));
                    // commit('H_03_LIST', gripUtil.cloneObject(h03List));
                    // commit('H_04_LIST', gripUtil.cloneObject(h04List));
                    // commit('H_05_LIST', gripUtil.cloneObject(h05List));
                    // commit('H_06_LIST', gripUtil.cloneObject(h06List));
    
                    commit('H_01_LIST', lodash.cloneDeep(h01List));
                    commit('H_02_LIST', lodash.cloneDeep(h02List));
                    commit('H_03_LIST', lodash.cloneDeep(h03List));
                    commit('H_04_LIST', lodash.cloneDeep(h04List));
                    commit('H_05_LIST', lodash.cloneDeep(h05List));
                    commit('H_06_LIST', lodash.cloneDeep(h06List));
                });
            });
        },
        // 약국 데이터
        FETCH_PHAR_FAC_LIST({commit}) {
            return commonApi.fetchRepoDataList($_DKD.PHARMACY).then(res => {
                commonApi.fetchRepoDataList($_DKD.PHARMACY_SUGI).then(response => {
                    // 수기 자료 추가(24시간 약국)
                    let p11List = response.data.data;

                    let list = res.data.data;
                    let p07List = [];
                    let p08List = [];
                    let p09List = [];
                    let p10List = [];
                    list.forEach(data => {
                        // 야간 운영 2100-2200까지 운영
                        if(data.val6 <= 2200 && data.val6 > 2100
                            || data.val8 <= 2200 && data.val8 > 2100
                            || data.val10 <= 2200 && data.val10 > 2100
                            || data.val12 <= 2200 && data.val12 > 2100
                            || data.val14 <= 2200 && data.val14 > 2100
                            || data.val16 <= 2200 && data.val16 > 2100
                            || data.val18 <= 2200 && data.val18 > 2100
                            || data.val20 <= 2200 && data.val20 > 2100
                        ) {
                            // 일주일에 3번 이상으로 제한
                            let cnt = 0;
                            if(data.val6 <= 2200 && data.val6 > 2100) cnt++;
                            if(data.val8 <= 2200 && data.val8 > 2100) cnt++;
                            if(data.val10 <= 2200 && data.val10 > 2100) cnt++;
                            if(data.val12 <= 2200 && data.val12 > 2100) cnt++;
                            if(data.val14 <= 2200 && data.val14 > 2100) cnt++;
                            if(data.val16 <= 2200 && data.val16 > 2100) cnt++;
                            if(data.val18 <= 2200 && data.val18 > 2100) cnt++;
                            if(data.val20 <= 2200 && data.val20 > 2100) cnt++;
                            if(cnt >= 3) {
                                p07List.push(data);
                            }
                        }
                        // 심야운영(22시 이후)
                        if(data.val6 > 2200
                            || data.val8 > 2200
                            || data.val10 > 2200
                            || data.val12 > 2200
                            || data.val14 > 2200
                            || data.val16 > 2200
                            || data.val18 > 2200
                            || data.val20 > 2200
                        ) {
                            p08List.push(data);
                        }
                        // 일요일 운영
                        if(typeof data.val17 != 'undefined' && data.val17 > 0) {
                            p09List.push(data);
                        }
                        // 공휴일 운영
                        if(typeof data.val19 != 'undefined' && data.val19 > 0) {
                            p10List.push(data);
                        }
                    });
                    // p07List.forEach(d => {
                    //     console.log('d', d.val1);
                    // });
                    // commit('P_07_LIST', gripUtil.cloneObject(p07List));
                    // commit('P_08_LIST', gripUtil.cloneObject(p08List));
                    // commit('P_09_LIST', gripUtil.cloneObject(p09List));
                    // commit('P_10_LIST', gripUtil.cloneObject(p10List));
    
                    commit('P_07_LIST', lodash.cloneDeep(p07List));
                    commit('P_08_LIST', lodash.cloneDeep(p08List));
                    commit('P_09_LIST', lodash.cloneDeep(p09List));
                    commit('P_10_LIST', lodash.cloneDeep(p10List));
                    // console.log('p11List', p11List);
                    commit('P_11_LIST', p11List);
                });
            });
        },
        // 아파트
        // 아파트 탭
        SET_SELECTED_AT_TAB({commit}, selectedAtTab) {
            commit('SELECTED_AT_TAB', selectedAtTab);
        },
        FETCH_APT_LIST({commit}, searchBasdt) {
            let q = '';
            // if(!!searchBasdt) {
            //     q = 'where=basdtVal::' + searchBasdt;
            // } else {
            //     q = "searchMaxBaseColumns=basdtVal";
            // }

            // 날짜별로 작업한 previous
            // return commonApi.fetchRepoDataList($_DKD.APART_TRADE, q).then(res => {
            //     let list = res.data.data;
            //     let map = gripUtil.toMap(list, 'basdtVal');
            //     let selectionList = [];
            //     for(let key in map) {
            //         selectionList.push(key);
            //     }
            //     selectionList = selectionList.sort((pre, cur) => {
            //         return cur - pre;
            //     });
            //     commit('APT_LIST', list);
            //     commit('APT_MAP', map);
            //     commit('SELECTION_LIST', selectionList);
            //     commit('SELECTED_DATE', selectionList[0]);
            // });
            // 아파트 별로 다시 작업
            return commonApi.fetchRepoDataList($_DKD.APART_TRADE, q).then(res => {
                let list = [];
                res.data.data.forEach(d => {
                    if(d.val11 != 'O'){
                        d.val5 = d.val5.replace(' ', '');
                        list.push(d);
                    }
                });
                // let list = res.data.data.filter(d => {
                //     return d.val11 != 'O';
                // });
                let map = gripUtil.toMap(list, 'val5');
                let selectionList = [];
                for(let key in map) {
                    selectionList.push(key);

                    map[key].areaList = [];

                    let areaMap = gripUtil.toMap(map[key], 'val6');
                    for(let k in areaMap) {
                        map[key].areaList.push(k);
                    }
                }
                selectionList = selectionList.sort((pre, cur) => {
                    return cur - pre;
                });
                commit('APT_LIST', list);
                commit('APT_MAP', map);
                commit('SELECTION_LIST', selectionList);
                commit('SELECTED_DATE', selectionList[0]);
            });
        },
        SET_SELECTED_DATE({commit}, selectedDate) {
            commit('SELECTED_DATE', selectedDate);
        },


        // 제목, 회사, 학력, 경력, 구인 사이트 url, 위경도(XXXX), 마감일자, 근무지 주소+근무지 상세주소, 급여, 근무형태
        FETCH_WORK_INCRUDE_INFO({commit}, cnt) {
            // 워크넷 - 채용정보
            let q = 'where=val24::025500&orderBy=basdtVal::desc';
            // let q = 'orderBy=basdtVal::desc';
            return commonApi.fetchRepoDataList($_DKD.WORKNET_INCRUDE_INFO, q).then(res => {
                // 워크넷 - 공채속보
                let qry = 'whereLike=val4::' + encodeURIComponent('공');
                qry += '&whereLike=val9::' + encodeURIComponent('서울');
                qry += '&orderBy=basdtVal::desc';
                commonApi.fetchRepoDataList($_DKD.WORKNET_INCRUDE_TROT, qry).then(rs => {
                    // 서울시 채용시험 정보
                    // let query = 'whereLike=val11::' + encodeURIComponent('강남');
                    // query += '&orderBy=basdtVal::desc';
                    let searchFromDate = new Date().getFullYear() + '010000';
                    // let query = 'orderBy=basdtVal::desc&searchFromDate=' + searchFromDate;
                    let query = 'orderBy=basdtVal::desc&searchFromDate=' + searchFromDate;
                    if(!!cnt) {
                        query += '&searchLimit=' + cnt;
                    }
                    commonApi.fetchRepoDataList($_DKD.SEOUL_WORK_INCRUDE_INFO, query).then(response => {
                        commonApi.fetchRepoDataListWithCodeName($_DKD.GOV_WORK_INCRUDE).then(respon => {
                            let qqq = 'orderBy=basdtVal::desc&searchFromDate='+ new Date().getFullYear()+ '0000';
                            commonApi.fetchRepoDataList($_DKD.SOG_WORKINCRUDE, qqq).then(rps => {
                                let sogList = rps.data.data;
                                // 링크 없는 항목은 표출하지 않음.
                                let govWorkList = respon.data.data.filter(d => {
                                    // console.log('d', d);
                                    let link = !!d.val9? d.val9 : !!d.val10 ? d.val10 : !!d.val11 ? d.val11 : undefined;
                                    return !!link;
                                });
                                // console.log('govWorkList', govWorkList);
                                // console.log('res', res.data.data);
                                let list = res.data.data;
                                list = list.filter(d => {
                                    return !d.val2.includes('주식') && !d.val2.includes('(주)');
                                });
                                let lst = rs.data.data;
                                // 강남구 데이터만 필터링
                                // lst = lst.filter(d => {
                                //     if(d.val9.includes('강남')) {
                                //         console.log('d', d);
                                //     }
                                // });
                                // console.log('response', response.data.data);
                                let incrudeList = response.data.data;
        
                                // 병합 데이터셋
                                let cbList = [];
                                list.forEach(data => {
                                    let combinedData = {
                                        type: '01',
                                        title: data.val3 ? data.val3 : '',
                                        company: data.val2 ? data.val2 : '',
                                        edu: data.val10 ? data.val10 : '',
                                        career: data.val12 ? data.val12 : '',
                                        url: data.val15 ? data.val15 : '',
                                        addr: data.val8 ? data.val8 : '',
                                        payment: data.val5 ? data.val5 : '',
                                        workCondition: data.val9 ? data.val9 : '',
                                        hireCondition: '',
                                        endDt: data.val13 ? data.val13 : '',
                                    }
                                    cbList.push(combinedData);
                                });
        
                                lst.forEach(data => {
                                    let combinedData = {
                                        type: '02',
                                        title: data.val2 ? data.val2 : '',
                                        company: data.val3 ? data.val3 : '',
                                        edu: '모집사이트 확인',
                                        career: '모집사이트 확인',
                                        url: data.val7 ? data.val7 : '',
                                        addr: data.val9 ? data.val9 : '',
                                        payment: '모집사이트 확인',
                                        workCondition: '',
                                        hireCondition: data.val5? data.val5 : '',
                                        endDt: data.basdtVal2.substring(2, data.basdtVal2.length),
                                    }
        
                                    cbList.push(combinedData);
                                });
                                // console.log('incrudeList', incrudeList);
                                // 제목에서 강남 이외 지역 거르기
                                incrudeList.forEach(data => {
                                    let combinedData = {
                                        type: '03',
                                        title: data.val2 ? data.val2 : '',
                                        company: '서울시',
                                        chargerInstt: data.val6 ? data.val6 : '',
                                        chargerDept: data.val7 ? data.val7 : '',
                                        url: data.val1? 'https://www.seoul.go.kr/news/news_employ.do#view/' + data.val1 : '',
                                        fileDownloadUrl: data.val15? data.val15 : '',
                                        fileName: data.val12 ? data.val12 : '',
                                        email: data.val9 ? data.val9 : '',
                                        tel: data.val8 ? data.val8 : '',
                                        // 게시종료일
                                        realEndDt: data.val21 ? data.val21.substring(2, 8) : '',
                                        // 다른 자료랑 일치하기 위해 시작일을 넣어둠
                                        endDt: data.val20 ? data.val20.substring(2, 8) : '',
                                    }
                                    cbList.push(combinedData);
                                });
    
                                govWorkList.forEach(data => {
                                    let combinedData = {
                                        type: '04',
                                        title: data.val6 ? data.val6 : '',
                                        company: data.val2 ? data.val2 : '',
                                        incrude1: data.valNm13 ? data.valNm13 : '',
                                        incrude2: data.valNm14 ? data.valNm14 : '',
                                        url: data.val9 ? data.val9 : data.val10 ? data.val10 : data.val11 ? data.val11 : '',
                                        addr: '강남구',
                                        payment: '상세확인',
                                        workCondition: '상세확인',
                                        hireCondition: '',
                                        endDt: data.basdtVal2.substring(2, data.basdtVal2.length),
                                    }
                                    // console.log('combinedData', combinedData);
                                    cbList.push(combinedData);
                                });

                                sogList.forEach(data => {
                                    let combinedData = {
                                        type: '05',
                                        title: data.val2 ? data.val2 : '',
                                        company: '강남구청',
                                        edu: '',
                                        career: '',
                                        url: 'https://www.gangnam.go.kr/notice/view.do?not_ancmt_mgt_no='+ data.val1 +'&mid=ID05_040202&gubunfield=05',
                                        addr: '서울 강남구 학동로',
                                        payment: '',
                                        workCondition: '',
                                        hireCondition: '',
                                        endDt: data.basdtVal ? data.basdtVal.substring(2, data.basdtVal.length) : '',
                                    }
                                    cbList.push(combinedData);
                                });
    
    
                                let date = new Date().format('yyMMdd');
                                let reg = /[^0-9]/g;
                                // let endDate = endDt.replace(this.reg, "");
                                cbList = cbList.filter(d => {
                                    if(d.type == '01' || d.type == '02') {
                                        let endDate = d.endDt.replace(reg, "");
                                        if(Number(date) < Number(endDate)) {
                                            return true;
                                        }
                                        return true;
                                    }
                                    if(d.type == '03') {
                                        if(Number(date) < Number(d.realEndDt)) {
                                            return true;
                                        }
                                    }
                                    if(d.type == '04' || d.type == '05') {
                                        return true;
                                    }
                                });
                                cbList = cbList.sort((pre, cur) => {
                                    // 'yyyy-mm-dd' 형태로 비교불가
                                    let preEdt = pre.endDt.replace(reg, "");
                                    let curEdt = cur.endDt.replace(reg, "");
                                    return Number(curEdt) - Number(preEdt);
                                });
                                commit('WORK_INCRUDE_INFO', cbList);

                            });
                        })
                    });

                });
            });
        },
        FETCH_WORK_INCRUDE_LIST({commit}) {
            return commonApi.fetchRepoDataList($_DKD.WORKNET_INCRUDE_TROT).then(res => {
                // console.log('res', res.data.data);
                commit('WORKNET_INCRUDE_TROT', res.data.data);
            });
        },
        FETCH_SEOUL_WORK_LIST({commit}) {
            return commonApi.fetchRepoDataList($_DKD.SEOUL_WORK_INCRUDE_INFO).then(res => {
                // console.log('res', res.data.data);
                commit('SEOUL_WORK_INCRUDE_INFO', res.data.data);
            });
        },

        FETCH_APT_LIST_ADDONG({commit}, searchBasdt) {
            let q = '';
            return commonApi.fetchRepoDataList($_DKD.APART_TRADE, q).then(res => {
                let list = [];
                res.data.data.forEach(d => {
                    if(d.val11 != 'O'){
                        // d.val5 = d.val5.replace(' ', '');
                        list.push(d);
                    }
                    d.val8 = d.val8.trim();
                    d.val5 = d.val5.trim().replaceAll(' ', '');
                });
                let aptMap = {};
                let map = gripUtil.toMap(list, 'val8');
                for(let k in map) {
                    let key = k.trim();
                    if(typeof aptMap[key] == 'undefined') {
                        aptMap[key] = gripUtil.toMap(map[k], 'val5');
                    }
                    
                }
                // console.log('aptMap', aptMap);
                let selectionMap = {};
                for(let key in aptMap) {
                    if(typeof selectionMap[key] == 'undefined') {
                        selectionMap[key] = [];
                    }
                    for(let k in aptMap[key]) {
                        selectionMap[key].push(k);
                    }

                    selectionMap[key] = selectionMap[key].sort((pre, cur) => {
                        return pre < cur ? -1 : pre > cur ? 1 : 0;
                    });
                }
                // for(let k in selectionMap) {
                //     selectionMap[k] = selectionMap[k].sort((pre, cur) => {
                //         return pre < cur ? -1 : pre > cur ? 1 : 0;
                //     });
                // }
                // console.log('selectionMap', selectionMap);

                commit('APT_LIST', list);
                commit('APART_MAP', aptMap);
                commit('SELECT_MAP', selectionMap);
                commit('SELECTED_DATE', selectionMap['도곡동'][1]);
            });
        },
    }
};
